import { orderTransactionTypes } from '@/constants'

export const getTransactionsNotAllowed = (availableTransactionTypes, availableTransactionTypesForRegion) => {
  let transactionsNotAllowed = availableTransactionTypes.filter(
    availableTransaction => !availableTransactionTypesForRegion.includes(availableTransaction)
  )

  return transactionsNotAllowed
}

export const joinTransactionTypes = (transactionTypes, t, language) => {
  const transactionTypesMapping = {
    [orderTransactionTypes.refund]: t('devoluciones'),
    [orderTransactionTypes.exchange]: t('cambios'),
    [orderTransactionTypes.mixed]: t('cambios y devoluciones'),
  }

  const formatter = new Intl.ListFormat(language, {
    style: 'long',
    type: 'conjunction',
  })

  return formatter.format(transactionTypes.map(transactionType => transactionTypesMapping[transactionType]))
}
